import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const pathStart = 'Home|Dashboard|';

const sharedProperties: Pick<LocDef, 'portal' | 'feature'> = {
	feature: HubFeature.CandidateAccess,
	portal: 'CP',
};

export type CPDashboardLocNames = 'CPDashboardPageTitle' | 'CPDashboardPageDescription';

export const cpDashboardLocs: LocDefs<CPDashboardLocNames> = {
	CPDashboardPageTitle: {
		defaultValue: 'Dashboard',
		description: 'Page and tab title for the dashboard.',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'CandidateAccess/Home.Dashboard.PageTitle',
		htmlAllowed: false,
		shared: true,
		...sharedProperties,
	},
	CPDashboardPageDescription: {
		defaultValue: '',
		description: 'Page description.',
		displayPath: `${pathStart}Page Description`,
		displayType: 'Content',
		legacyName: 'CandidateAccess/Home.Dashboard.Content.PageDescription',
		htmlAllowed: true,
		shared: false,
		...sharedProperties,
	},
};

export type CPDashboardLocType = LocMap<CPDashboardLocNames>;

export const LOC_KEYS = MapLocKeys<CPDashboardLocNames>(cpDashboardLocs);
